import React from 'react';

const MarkProductContext = React.createContext(() => {
  throw new Error('Used MarkProductContext.Consumer without a Provider');
});
const { Provider, Consumer } = MarkProductContext;

export default MarkProductContext;
export { Provider, Consumer };
